// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2739":"c6ca9f42","4920":"20d56640","5795":"f6aab943","7793":"b8d4e1aa","8316":"cb0b0c61"}[chunkId] + ".css";
};